import * as Selectors  from './selectors';
import { useSelector } from 'react-redux';


export function useGroups(businessID) {
  return useSelector(state => Selectors.getGroups(state, businessID));
}

export function useGroupsStatuses(businessID) {
  return useSelector(state => Selectors.getGroupsStatuses(state, businessID));
}

export function useGroup(groupID) {
  return useSelector(state => Selectors.getGroup(state, groupID));
}
